import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useLang, useL } from "@/lib/i18n";
import { api, errDetail, mtlToday, fmtDateTime } from "@/lib/api";
import { StatusBadge } from "@/components/member/Lists";
import { BookingTable } from "./Bookings";
import { F, Card, RedBtn } from "./ui";

export function AdminBlocks() {
  const L = useL();
  const { tErr } = useLang();
  const [f, setF] = useState({ date: mtlToday(1), start_time: "09:00", end_date: mtlToday(1), end_time: "12:00", reason: "Maintenance" });
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/admin/bookings", { params: { scope: "upcoming", kind: "block" } }).then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const add = async () => {
    try { await api.post("/admin/blocks", f); toast.success(L("Bloc ajouté", "Block added")); load(); }
    catch (e) { toast.error(tErr(errDetail(e)) + (errDetail(e) === "slot_unavailable" ? L(" (réservations existantes)", " (existing bookings)") : "")); }
  };
  const remove = async (b) => { await api.post(`/admin/bookings/${b.id}/cancel`, { refund: false }); load(); };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="space-y-6">
      <Card title={L("Bloquer le studio (maintenance)", "Block studio (maintenance)")} testId="admin-blocks-form">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-6 lg:items-end">
          <F id="block-start-date" label={L("Début", "Start")} type="date" value={f.date} onChange={set("date")} />
          <F id="block-start-time" label={L("Heure", "Time")} type="time" step="900" value={f.start_time} onChange={set("start_time")} />
          <F id="block-end-date" label={L("Fin", "End")} type="date" value={f.end_date} onChange={set("end_date")} />
          <F id="block-end-time" label={L("Heure", "Time")} type="time" step="900" value={f.end_time} onChange={set("end_time")} />
          <F id="block-reason" label={L("Raison", "Reason")} value={f.reason} onChange={set("reason")} />
          <RedBtn onClick={add} data-testid="block-submit-btn">{L("Bloquer", "Block")}</RedBtn>
        </div>
      </Card>
      <Card title={L("Blocs à venir", "Upcoming blocks")}><BookingTable items={items} onCancel={remove} testId="admin-blocks-table" /></Card>
    </div>
  );
}

export function AdminKeycards() {
  const L = useL();
  const { lang } = useLang();
  const [members, setMembers] = useState([]);
  const [sched, setSched] = useState(null);
  useEffect(() => {
    api.get("/admin/members").then((r) => setMembers(r.data));
    api.get("/admin/keycards/access-schedule").then((r) => setSched(r.data));
  }, []);
  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-amber-500/40 bg-amber-950/30 p-4 text-sm text-amber-200" data-testid="keycard-manual-notice">
        {L("Gestion manuelle — aucun système de porte n'est connecté. Ce site n'ouvre, ne désactive ni ne contrôle aucune porte physique. Activez ou désactivez les cartes directement sur votre système d'accès.",
          "Manual management — no door system is connected. This website does not open, disable or control any physical door. Activate or deactivate cards directly on your access system.")}
      </div>
      <Card title={L("Cartes d'accès", "Keycards")} testId="admin-keycards">
        <div className="overflow-x-auto"><table className="w-full min-w-[520px] text-sm"><tbody>
          {members.map((m) => (
            <tr key={m.id} className="border-b border-white/5"><td className="py-2.5 text-white">{m.name}</td><td className="font-mono text-slate-300">{m.keycard?.number || "—"}</td>
              <td><StatusBadge s={m.keycard?.status || "unassigned"} /></td><td className="text-xs text-slate-500">{m.keycard?.notes}</td></tr>
          ))}
        </tbody></table></div>
        <p className="mt-3 text-xs text-slate-500">{L("Modifiez une carte depuis l'onglet Membres.", "Edit a keycard from the Members tab.")}</p>
      </Card>
      <Card title={L("Horaire d'accès (prêt pour intégration future)", "Access schedule (ready for future integration)")} testId="admin-access-schedule">
        <p className="mb-3 text-xs text-slate-500">{L("Fenêtres de réservations confirmées des 7 prochains jours par carte active. Exportable vers un futur système compatible.", "Confirmed booking windows for the next 7 days per active keycard. Exportable to a future compatible system.")}</p>
        <ul className="space-y-1 font-mono text-xs text-slate-300">
          {(sched?.windows || []).map((w, i) => <li key={i}>{w.keycard} · {w.member} · {fmtDateTime(w.start, lang)} → {fmtDateTime(w.end, lang)}</li>)}
          {sched && !sched.windows.length && <li className="text-slate-500">—</li>}
        </ul>
      </Card>
    </div>
  );
}

